import { render, staticRenderFns } from "./Roadside.vue?vue&type=template&id=72a382d3&"
import script from "./Roadside.vue?vue&type=script&lang=js&"
export * from "./Roadside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports